"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _1 = require("./");
var inversify_1 = require("inversify");
var Root = /** @class */ (function () {
    function Root(items, payment) {
        this.items = items;
        this.payment = payment;
    }
    var _a, _b;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ShoppingCartItemClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ShoppingCartPaymentClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ShoppingCartItemClient !== "undefined" && _1.ShoppingCartItemClient) === "function" ? _a : Object, typeof (_b = typeof _1.ShoppingCartPaymentClient !== "undefined" && _1.ShoppingCartPaymentClient) === "function" ? _b : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;
